import { uuid } from '../utils'
import Vue from 'vue'
import { reportQuery } from '../api'

const emptyTpl = {
  // basic
  type: '',
  groupBy: '',
  dateType: '',
  dateRange: '',
  tagAll: true,
  selectedTags: [],
  includeCost: false,
  unsoldDays: '',
  qtyCriterion: '',
  source: '',
  // warehouse
  selectedWh: [],
  warehouseAll: true,
  // out warehouse
  selectedOutWh: [],
  outWarehouseAll: true,
  // in warehouse
  selectedInWh: [],
  inWarehouseAll: true,
  // product filter
  products: [],
  productAll: true,
  brandAll: true,
  selectedBrands: [],
  categoryAll: true,
  selectedCategories: [],
  // csr filter
  csrCreated: '',
  areasAll: true,
  selectedAreas: [],
  paymentsAll: true,
  selectedPayments: [],
  csrAll: true,
  selectedCsrs: [],
  dueDate: '',
  unSold: '',
  // supplier filter
  supplierAll: true,
  selectedSuppliers: []
}

export default {
  namespaced: true,
  state: { ...emptyTpl },
  getters: {
    product: state => id => state.products.find(p => p.id === id)
  },
  mutations: {
    // init: state => (state = { ...tpl }),
    // 改为同order-search，order-edit一样的深拷贝
    init: state => {
      // deep copy tpl here
      const tpl = JSON.parse(JSON.stringify(emptyTpl))
      for (const prop in state) {
        Vue.set(state, prop, tpl[prop])
      }
    },
    setType: (state, type) => (state.type = type),
    setGroupBy: (state, type) => (state.groupBy = type),
    setSource: (state, source) => (state.source = source),
    setDateType: (state, type) => (state.dateType = type),
    setDateRange: (state, range) => (state.dateRange = range),
    setTags: (state, tags) => (state.selectedTags = tags),
    setTagAll: (state, tagAll) => (state.tagAll = !!tagAll),
    setWarehouses: (state, warehouses) => (state.selectedWh = warehouses),
    setWarehoueAll: (state, all) => (state.warehouseAll = !!all),
    setOutWarehouses: (state, warehouses) => (state.selectedOutWh = warehouses),
    setOutWarehoueAll: (state, all) => (state.outWarehouseAll = !!all),
    setInWarehouses: (state, warehouses) => (state.selectedInWh = warehouses),
    setInWarehoueAll: (state, all) => (state.inWarehouseAll = !!all),
    setIncludeCost: (state, inlude) => (state.includeCost = !!inlude),
    setProductAll: (state, all) => (state.productAll = !!all),
    addNewProductLine: state =>
      state.products.push({ id: uuid(), product: {} }),
    setProduct: (state, { id, product }) => {
      const index = state.products.findIndex(item => item.id === id)
      if (index !== -1) {
        Vue.set(state.products, index, { id, product })
      }
    },
    deleteProduct: (state, id) => {
      const index = state.products.findIndex(p => p.id === id)
      if (index !== -1) {
        state.products.splice(index, 1)
      }
    },
    setBrands: (state, brands) => (state.selectedBrands = brands),
    setBrandAll: (state, all) => (state.brandAll = !!all),
    setCategories: (state, categories) =>
      (state.selectedCategories = categories),
    setCategoryAll: (state, all) => (state.categoryAll = !!all),
    setCsrCreated: (state, range) => (state.csrCreated = range),
    setAreas: (state, areas) => (state.selectedAreas = areas),
    setAreaAll: (state, all) => (state.areasAll = !!all),
    setPayments: (state, payments) => (state.selectedPayments = payments),
    setPaymentsAll: (state, all) => (state.paymentsAll = !!all),
    setCsr: (state, { id, csr }) => {
      const index = state.selectedCsrs.findIndex(item => item.id === id)
      if (index !== -1) {
        Vue.set(state.selectedCsrs, index, { id, csr })
      }
    },
    setSupplier: (state, { id, supplier }) => {
      const index = state.selectedSuppliers.findIndex(item => item.id === id)
      if (index !== -1) {
        Vue.set(state.selectedSuppliers, index, { id, supplier })
      }
    },
    addNewCSRLine: state => state.selectedCsrs.push({ id: uuid(), csr: {} }),
    addNewSupplierLine: state =>
      state.selectedSuppliers.push({ id: uuid(), supplier: {} }),
    setCSRAll: (state, all) => (state.csrAll = !!all),
    setSupplierAll: (state, all) => (state.supplierAll = !!all),
    deleteCSR: (state, id) => {
      const index = state.selectedCsrs.findIndex(p => p.id === id)
      if (index !== -1) {
        state.selectedCsrs.splice(index, 1)
      }
    },
    deleteSupplier: (state, id) => {
      const index = state.selectedSuppliers.findIndex(p => p.id === id)
      if (index !== -1) {
        state.selectedSuppliers.splice(index, 1)
      }
    },
    setDueDate: (state, date) => (state.dueDate = date),
    setUnsold: (state, unSold) => (state.unSold = unSold),
    setQtyCriterion: (state, qty) => (state.qtyCriterion = qty)
  },
  actions: {
    initInvDetails: ({ commit }) => {
      commit('init')
      commit('setType', 'inv-details')
      commit('setDateType', 'date')
    },
    initSaleSummary: ({ commit }) => {
      commit('init')
      commit('setType', 'inv-summary')
      commit('setDateType', 'date')
    },
    initSlowMoving: ({ commit }) => {
      commit('init')
      commit('setType', 'inv-slowMoving')
    },
    initPurDetails: ({ commit }) => {
      commit('init')
      commit('setType', 'bills')
      commit('setDateType', 'date')
    },
    initPurSummary: ({ commit }) => {
      commit('init')
      commit('setType', 'po')
      commit('setDateType', 'date')
    },
    initTransDetails: ({ commit }) => {
      commit('init')
      commit('setType', 'trans-details')
      commit('setDateType', 'date')
    },
    initAjDetails: ({ commit }) => {
      commit('init')
      commit('setType', 'aj-details')
      commit('setDateType', 'date')
    },
    initInventorySummary: ({ commit }) => {
      commit('init')
      commit('setType', 'inventory-summary')
      commit('setDateType', 'date')
    },
    initInventoryDetails: ({ commit }) => {
      commit('init')
      commit('setType', 'inventory-details')
      commit('setDateType', 'date')
    },
    invoiceDetails: async ({ state }) => {
      const params = {
        type: state.type
      }

      if (state.type === 'inv-details') {
        params.group = state.groupBy
      }

      if (state.dateRange !== '') {
        params.dateType = state.dateType
        params.dateRange = state.dateRange
      }

      if (!state.tagAll && state.selectedTags.length > 0) {
        params.tags = state.selectedTags.map(item => item.value)
      }

      if (!state.warehouseAll && state.selectedWh.length > 0) {
        params.warehouses = state.selectedWh.map(item => item.value)
      }

      if (state.includeCost) {
        params.includeCost = state.includeCost
      }

      if (!state.brandAll && state.selectedBrands.length > 0) {
        params.brands = state.selectedBrands.map(item => item.id)
      }

      if (!state.categoryAll && state.selectedCategories.length > 0) {
        params.categories = state.selectedCategories.map(item => item.value)
      }

      if (!state.productAll && state.products.length > 0) {
        params.products = state.products.map(item => item.product.id)
      }

      if (state.csrCreated !== '') {
        params.csrCreated = state.csrCreated
      }

      if (!state.areasAll && state.selectedAreas.length > 0) {
        params.areas = state.selectedAreas.map(item => item.name)
      }

      if (!state.paymentsAll && state.selectedPayments.length > 0) {
        params.payments = state.selectedPayments.map(item => item.name)
      }

      if (!state.csrAll && state.selectedCsrs.length > 0) {
        params.csrs = state.selectedCsrs.map(item => item.csr.id)
      }

      if (state.dueDate !== '') {
        params.dueDate = state.dueDate
      }

      if (state.unSold > 0) {
        params.unSoldDay = state.unSold
      }

      if (state.qtyCriterion > 0) {
        params.lessThan = state.qtyCriterion
      }

      return reportQuery(params)
    },

    purchaseDetails: async ({ state }) => {
      const params = {
        type: state.type,
        source: state.source
      }

      if (state.dateRange !== '') {
        params.dateType = state.dateType
        params.dateRange = state.dateRange
      }

      if (!state.brandAll && state.selectedBrands.length > 0) {
        params.brands = state.selectedBrands.map(item => item.id)
      }

      if (!state.categoryAll && state.selectedCategories.length > 0) {
        params.categories = state.selectedCategories.map(item => item.value)
      }

      if (!state.supplierAll && state.selectedSuppliers.length > 0) {
        params.Suppliers = state.selectedSuppliers.map(item => item.supplier.id)
      }

      return reportQuery(params)
    },

    inventoryDetails: async ({ state }) => {
      const params = {
        type: state.type
      }

      if (state.dateRange !== '') {
        params.dateType = state.dateType
        params.dateRange = state.dateRange
      }

      if (!state.warehouseAll && state.selectedWh.length > 0) {
        params.warehouses = state.selectedWh.map(item => item.value)
      }

      if (!state.outWarehouseAll && state.selectedOutWh.length > 0) {
        params.outWarehouse = state.selectedOutWh.map(item => item.value)
      }

      if (!state.inWarehouseAll && state.selectedInWh.length > 0) {
        params.inWarehouse = state.selectedInWh.map(item => item.value)
      }

      if (!state.brandAll && state.selectedBrands.length > 0) {
        params.brands = state.selectedBrands.map(item => item.id)
      }

      if (!state.categoryAll && state.selectedCategories.length > 0) {
        params.categories = state.selectedCategories.map(item => item.value)
      }

      if (!state.productAll && state.products.length > 0) {
        params.products = state.products.map(item => item.product.id)
      }

      return reportQuery(params)
    }
  }
}
